module.exports = __webpack_public_path__ + "static/media/message-fill.efad0f33.svg";